module.exports = __webpack_public_path__ + "prod/1.2.3/img/default-3.1873fbd2.png";